import { AspectRatio, Flex, HStack, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'

const Insulation = () => {
  return (
    <Flex
      w="100%"
      justifyContent="center"
      alignItems="flex-end"
      position="relative"
      h="100%"
    >
      <VStack
        alignItems="flex-start"
        justifyContent="flex-end"
        zIndex={10}
        position="absolute"
        top="39%"
        left="49%"
      >
        <HStack
          w={{
            base: '340px',
            lg: '100%'
          }}
          justifyContent="center"
          gap={{
            base: 0,
            lg: 8
          }}
        >
          <VStack gap={0}>
            <AspectRatio
              w={{
                base: '50px',
                xl: '80px'
              }}
              ratio={1 / 1}
              position="relative"
              zIndex={10}
            >
              <Image
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/keep-cool-1711633012268.png"
                alt="keep cool"
                fill
              />
            </AspectRatio>
            <Text
              fontSize={{
                base: 13,
                xl: 18
              }}
              fontWeight={500}
              lineHeight={1.2}
              textAlign="center"
              w={{
                base: '110px',
                xl: '160px'
              }}
              mt={2}
            >
              Keep cold for up to 24 hours
            </Text>
          </VStack>

          <VStack gap={0}>
            <AspectRatio
              w={{
                base: '50px',
                xl: '80px'
              }}
              ratio={1 / 1}
              position="relative"
              zIndex={10}
            >
              <Image
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/keep-warm-1711633012268.png"
                alt="keep warm"
                fill
              />
            </AspectRatio>
            <Text
              fontSize={{
                base: 13,
                xl: 18
              }}
              fontWeight={500}
              lineHeight={1.2}
              textAlign="center"
              w={{
                base: '110px',
                xl: '160px'
              }}
              mt={2}
            >
              Keep warm for up to 12 hours
            </Text>
          </VStack>
        </HStack>

        <Text
          textStyle="gripProblemTitle"
          textTransform="uppercase"
          textAlign="left"
          w={{
            base: '360px',
            lg: '400px',
            xl: '580px'
          }}
          mt={{
            base: 0,
            xl: 5
          }}
        >
          SUPERIOR INSULATION
        </Text>
        <Text
          textStyle="gripInsulationContent"
          textAlign="left"
          w={{
            base: '342px',
            lg: '400px',
            xl: '560px'
          }}
          mb={{
            md: '40px',
            lg: '80px'
          }}
          mt={{
            base: 0,
            xl: 5
          }}
        >
          Say goodbye to lukewarm drinks! Our tumbler features superior
          double-wall vacuum insulation that keeps your beverages cold for up to
          24 hours and hot for up to 12 hours. No matter the weather, enjoy your
          drinks at the perfect temperature.
        </Text>
      </VStack>
    </Flex>
  )
}

export default Insulation
